import {
	createRouter,
	createWebHistory
} from 'vue-router';

import Scenicspot from '../views/scenicspot.vue'
import Guide from '../views/guide.vue'
import Detail from '../views/detail.vue'
import GuideMap from '../views/guidemap.vue'

const routes = [{
		path: "/scenicspot",
		name: '景点列表',
		component: Scenicspot
	},
	{
		path: "/guide",
		name: '游玩攻略',
		component: Guide
	},
	{
		path: "/detail",
		name: '攻略详情',
		component: Detail
	},
	{
		path: "/guidemap",
		name: '导览图',
		component: GuideMap
	}
	


]
const router = createRouter({
	mode: 'hash', // 设置为hash模式
	history: createWebHistory(),
	routes
});
export default router;
